import { getDateFingerprint, FingerprintLoader } from './base';

class ServerFingerprint extends FingerprintLoader {
  load(): void {
    this.onLoad(getDateFingerprint('ssr'));
  }
}

export { ServerFingerprint };
